import { createAction, props } from '@ngrx/store';
import { LoginRequest, LoginSuccess } from 'src/app/core/models/auth.models';

export const loginRequest = createAction(
    '[Auth] Loggin user',
    props<{ login: LoginRequest }>()
);

export const loginFailed = createAction(
    '[Auth] Loggin failed'
);

export const loginSuccess = createAction(
    '[Auth] Loggin success',
    props<{ data: LoginSuccess }>()
);

export const logoutRequest = createAction(
    '[Auth] Loggout user',
    props<{ deviceId: string | null }>()
);

export const logoutFailed = createAction(
    '[Auth] Logout failed'
);

export const logoutSuccess = createAction(
    '[Auth] Logout success'
);